export const NEWSLETTER_TONES = [
  "Direct", "Sharp", "Calm", "Contrarian", "Insightful", "Practical",
  "Urgent", "Warm", "Provocative", "Authoritative", "Conversational",
];

export const NEWSLETTER_GOALS = [
  "Build trust and authority",
  "Educate and add value",
  "Drive engagement and replies",
  "Move to CTA",
  "Generate leads",
  "Warm cold audience",
  "Re-engage existing audience",
];

export const NEWSLETTER_LOADING_MESSAGES = [
  "Writing the opening hook...",
  "Developing the core insight...",
  "Building the tactical section...",
  "Crafting the closing...",
  "Polishing every section...",
];

export const NEWSLETTER_SECTION_TOGGLES = [
  { label: "Story / Example", id: "story", stateKey: "includeStory" },
  { label: "Tactical Breakdown", id: "tactical", stateKey: "includeTactical" },
  { label: "Resource of the Week", id: "resource", stateKey: "includeResource" },
];
